import React, { ReactNode } from "react";
import { Typography, TypographyProps } from "@mui/material";

type CustomTypographyComponentProps = TypographyProps & {
  children?: ReactNode;
};

export const CustomTypographyComponent = (props: CustomTypographyComponentProps) => <Typography {...props} />;

export default CustomTypographyComponent;
